const sortObj = (obj: unknown): unknown =>
  obj === null || typeof obj !== 'object'
    ? obj
    : Array.isArray(obj)
    ? obj.map(sortObj)
    : Object.assign(
        {},
        ...Object.entries(obj)
          .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
          .map(([k, v]) => ({ [k]: sortObj(v) })),
      );

export const deterministicStringify = (obj: unknown) =>
  JSON.stringify(sortObj(obj));
